import { render, staticRenderFns } from "./procedures.vue?vue&type=template&id=5eb80c23&scoped=true&"
import script from "./procedures.vue?vue&type=script&lang=js&"
export * from "./procedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb80c23",
  null
  
)

export default component.exports